/**
 * 抽奖组件
 */
import {
  useEffect,
  useState,
  useMemo,
  useImperativeHandle,
  forwardRef,
  useRef,
} from "react";
import { Toast } from "@xp-design/mobile";
import { getActivityInfo } from "@/api/configPage.ts";
import "./index.less";

import { parseJson, renderStyle } from "@/pages/par-marketing/configPage/utils";
import LuckyWheel from "./components/LuckyWheel";
import SlotMachine from "./components/SlotMachine";
import Fanpai from "./components/Fanpai";
import TaskList from "./components/taskList";
import TopButtonGroup from "./components/TopButtonGroup";
import ActivityDetailPopup, {
  ActivityDetailPopupRef,
} from "@/components/ActivityDetailPopup";
import { showLoading, hideLoading } from "@/utils/common";
import { processOssImage } from "@/utils/image";

const Lottery = forwardRef(
  (
    props: {
      // setSharePanelVisible: any;
      pageVersionDto: any;
      onGainPrize(arg0: {
        isWin: boolean;
        prizeUrl: any;
        winBg: any;
        noWinBg: any;
        productName: any;
        singleDistributionCount: any;
      }): any;
      activityInfo: any;
      showKeyIdx: number;
      onShowKeyIdx: Function;
      pageModuleDto: any;
      prizeDialogVisible?: Boolean;
    },
    ref,
  ) => {
    const { showKeyIdx, onShowKeyIdx } = props;
    const [pageInfo, setPageInfo] = useState<any>({}); // 全部数据
    const [actInfo, setActInfo] = useState<any>({}); // 活动信息

    // 活动详情弹窗引用
    const activityDetailPopupRef = useRef<ActivityDetailPopupRef>(null);

    const [activityStatusList] = useState({
      "0": "内测",
      "3-1": "待开始",
      "3-2": "进行中",
      "3-3": "已结束",
    });

    /**
     * 翻牌抽奖
     */
    const isTurnCard = useMemo(() => {
      return pageInfo?.visual?.visualData[0].typeName == "翻牌";
    }, [pageInfo]);
    const fanpaiRef = useRef();

    /**
     * 老虎机抽奖
     */
    const isSlots = useMemo(() => {
      return pageInfo?.visual?.visualData[0].typeName == "摇奖机";
    }, [pageInfo]);
    const slotMachineRef = useRef();
    const btnUrl = useMemo(
      () => pageInfo?.visual?.prizeSetting[1].content[0]?.val,
      [pageInfo],
    );

    /**
     * 大转盘抽奖
     */
    const isTurntable = useMemo(() => {
      return pageInfo?.visual?.visualData[0].typeName == "转盘";
    }, [pageInfo]);
    const luckyRef = useRef();

    useEffect(() => {
      console.log("props.activityInfo", props);
      if (props.activityInfo) {
        const data = parseJson(props.activityInfo.moduleJson) || {};
        console.log("data ====>", data);
        setPageInfo(() => data);
        getDetail(data.base[0].val.valCode, false);
      }
    }, [props.activityInfo]);

    useImperativeHandle(ref, () => {
      return {
        closePrize: () => {
          fanpaiRef.current?.onCloseDialog?.();
        },
        getActivityInfo: () => {
          getDetail(pageInfo.base[0].val.valCode, true);
        },
      };
    });

    // 获取活动详情
    const getDetail = async (activityCode) => {
      try {
        showLoading();
        if (!activityCode) {
          throw new Error("activityCode不能为空");
        }
        const res = await getActivityInfo({
          activityCode,
        });
        if (res.code === 200) {
          setActInfo(() => res.data);
        } else {
          Toast.show({
            content: res.msg,
          });
        }
      } catch (error: any) {
        console.error(error);
      } finally {
        hideLoading();
      }
    };

    const handleAfterDraw = (prizeData: any) => {
      props?.onGainPrize?.(prizeData);
      // 刷新页面
      getDetail(pageInfo.base[0].val.valCode, true);
    };

    // 文案风格样式列表
    const styleList = pageInfo?.visual?.prizeSetting[3].content[0].options.map(
      (item) => {
        item.styleObject = renderStyle(item.styleData); // 生成style对象
        return item;
      },
    );
    return (
      <div
        className="fanpai"
        id="fanpai"
        style={{
          backgroundImage: `url(${processOssImage(pageInfo?.visual?.prizeSetting[0]?.content[0]?.val || "")})`,
          backgroundSize: "100% 100%",
        }}
      >
        {/* 顶部按钮组 */}
        <TopButtonGroup
          pageInfo={pageInfo}
          activityInfo={props.activityInfo}
          activityDetailPopupRef={activityDetailPopupRef}
        />

        {/* 主标题 */}
        <div className="title" style={styleList?.[0]?.styleObject}>
          {pageInfo?.visual?.visualData[1].val}
        </div>

        {/* 副标题 */}
        <div className="subTitle" style={styleList?.[1]?.styleObject}>
          {pageInfo?.visual?.visualData[2].val}
        </div>

        {/* 翻卡列表 */}
        {isTurnCard && (
          <Fanpai
            ref={fanpaiRef}
            pageInfo={pageInfo}
            activityInfo={props.activityInfo}
            activityStatusList={activityStatusList}
            actInfo={actInfo}
            showKeyIdx={showKeyIdx}
            onShowKeyIdx={onShowKeyIdx}
            afterDraw={handleAfterDraw}
          />
        )}

        {/* 转盘 */}
        {isTurntable && (
          <div className="LuckyWheel">
            <LuckyWheel
              ref={luckyRef}
              pageInfo={pageInfo}
              activityInfo={props.activityInfo}
              activityStatusList={activityStatusList}
              actInfo={actInfo}
              btnUrl={btnUrl}
              afterDraw={handleAfterDraw}
            />
          </div>
        )}
        {/* 老虎机 */}
        {isSlots && (
          <div className="SlotMachine">
            <SlotMachine
              ref={slotMachineRef}
              pageInfo={pageInfo}
              activityInfo={props.activityInfo}
              activityStatusList={activityStatusList}
              actInfo={actInfo}
              btnUrl={btnUrl}
              afterDraw={handleAfterDraw}
            />
          </div>
        )}

        {/* 任务 */}
        {pageInfo?.prizeTasks?.visualData?.[0].val === "1" && (
          <TaskList
            actInfo={actInfo}
            pageInfo={pageInfo}
            activityStatusList={activityStatusList}
            activityInfo={props.activityInfo}
            pageModuleDto={props.pageModuleDto}
            pageVersionDto={props.pageVersionDto}
            // setSharePanelVisible={props.setSharePanelVisible}
          />
        )}

        {/* 活动详情弹窗组件 */}
        <ActivityDetailPopup ref={activityDetailPopupRef} />
      </div>
    );
  },
);

export default Lottery;
